import '@hotwired/turbo-rails'
import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'
import '../stylesheets/application.css'
import { startGoogleAnalytics } from '../google_analytics'

const application = Application.start()
window.Stimulus = application

const controllers = import.meta.glob('../controllers/**/*_controller.{js,ts}', { eager: true })
registerControllers(application, controllers)

// GA4 page views (Turbo-aware; no-op unless the <meta name="ga-id"> is present).
startGoogleAnalytics()
